/// <reference path="../svg.d.ts" />
import React from 'react';
import { getIconProps, IconProps } from '../utils';
import DateSvg from '../assets/ui/date.svg?react';

export const DateIcon: React.FC<IconProps> = props => {
  return <DateSvg {...getIconProps(props)} />;
};
